module.exports = __webpack_public_path__ + "img/check.060a7015.svg";